import React from "react";

import ongData from '../scripts/formOng';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/system/Unstable_Grid';
import Container from '@mui/material/Container';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const AccordionOdd = ({oddOptions, servicesOdd, handleServicesOddChange}) => {

    const findSousService = (label) => {
        for (let i = 0; i < ongData.services.length; i++) {
            if (ongData.services[i].label === label) return ongData.services[i].sous_service;      
        }

        return null;
    }

    const handleSelection = (service, value, checked) => {
        if (checked) {
            const updatedServicesOdd = {
                ...servicesOdd,
                [service]: servicesOdd[service] ? [...servicesOdd[service], value] : [value]
            };
            handleServicesOddChange(updatedServicesOdd);
        } else {
            const updatedServicesOdd = {
                ...servicesOdd,
                [service]: servicesOdd[service].filter(item => item !== value)
            };
            handleServicesOddChange(updatedServicesOdd);
        }
    };

    return (
        <Container sx={{ mt: 5 }}>
            <Grid container spacing={2}>
                {oddOptions.map((x, index) => (
                    <Grid xs={6} key={index}>
                        <Accordion slotProps={{ transition: { unmountOnExit: true } }} key={index}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index + 1}-content`}
                                id={`panel${index + 1}-header`}
                            >
                                {x}
                            </AccordionSummary>
                            <AccordionDetails>
                                {findSousService(x).map((y, innerIndex) => (
                                    <FormGroup key={innerIndex}>
                                        <FormControlLabel 
                                            control={
                                            <Checkbox 
                                                value={y.value}
                                                onChange={(event) => { handleSelection(x, event.target.value, event.target.checked); }}
                                                checked={servicesOdd[x]?.includes(y.value) || false}

                                            />}
                                            label={y.label}
                                            key={innerIndex}
                                        />
                                    </FormGroup>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
};

export default AccordionOdd;